module.exports = __webpack_public_path__ + "res/7-img_other_action.8e5fa9391e58f24ac8eaeb82c79bbea8.png";